import {VehicleActionTypes} from "./vehicle.types";

const INITIAL_STATE = {
  vehicles: undefined,
  vehicle: undefined,
  vehiclesMapData: undefined,
};

const vehicleReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VehicleActionTypes.SET_VEHICLES:
      return {
        ...state,
        vehicles: action.payload,
      };
      case VehicleActionTypes.SET_VEHICLE:
      return {
        ...state,
        vehicle: action.payload,
      };
      case VehicleActionTypes.SET_VEHICLES_MAP_DATA:
        return {
          ...state,
        vehiclesMapData: action.payload,
        };
    default:
      return state;
  }
};

export default vehicleReducer;